import Config from '../../../config/Config'
import {
  filter,
  map,
  mergeMap,
  catchError,
  withLatestFrom,
} from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import * as actions from '../actions'
import * as selectors from '../selectors'
import queryString from '@promoboxx/query-string-babel'

const fields = [
  'access_invitations',
  'access_invitations.accessible',
  'access_invitations.sender',
  'access_requests',
  'actionable_access_requests',
  'orphaned_retailers',
  'permissions',
  'registration_keys',
  'registration_keys.brand',
  'retailer_accounts',
  'retailer_accounts.retailers',
  'retailer_accounts.retailers.brand',
  'retailer_accounts.retailers.brand.digital_asset_tags',
  'retailer_accounts.retailers.brand.industry_list',
  'retailer_accounts.retailers.brand.settings',
  'retailer_accounts.retailers.sso_enabled',
  'stripe_stored_card',
  'user_roles',
]

function getAuthHeaders(xhr) {
  return {
    'access-token': xhr.getResponseHeader('access-token'),
    'token-type': 'Bearer',
    'client': xhr.getResponseHeader('client'),
    'expiry': xhr.getResponseHeader('expiry'),
    'uid': xhr.getResponseHeader('uid'),
  }
}

// AJAX call to validate token
export const validateAuth = (action$, state$) => {
  // Variables with $ indicate a stream...
  return action$.pipe(
    filter((action) => action.type === actions.VALIDATE_AUTH),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      let headers = selectors.headersSelector(state)
      if (!headers) {
        headers = action.payload
      }
      if (!headers) {
        //Don't continue if we don't have any headers to validate...
        throw new Error('Bad or Non-existent auth headers')
      }

      //Build validate_token URL w/ params
      const params = {
        fields,
      }
      const queryParams = queryString.stringify(params, {
        arrayFormat: 'bracket',
        encode: true,
      })
      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/auth/validate_token.json?${queryParams}`,
      }

      return ajax(settings).pipe(
        map((payload) => {
          const headers = getAuthHeaders(payload.xhr)
          return {
            type: actions.VALIDATE_AUTH_FULFILLED,
            payload: {
              user: payload.response.user,
              headers,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.VALIDATE_AUTH_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
    catchError((error) => {
      return of({
        type: actions.VALIDATE_AUTH_REJECTED,
        payload: error,
      })
    }),
  )
}

export const resetPassword = (action$) => {
  return action$.pipe(
    filter((action) => action.type === actions.RESET_PASSWORD),
    mergeMap((action) => {
      const settings = {
        method: 'POST',
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        url: `${Config.API_BASE}/auth/password`,
        body: action.payload,
      }

      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.RESET_PASSWORD_FULFILLED,
            payload: payload.response,
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.RESET_PASSWORD_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
  )
}

// AJAX call to request access
export const requestAccess = (action$) => {
  return action$.pipe(
    filter((action) => action.type === actions.REQUEST_ACCESS),
    mergeMap((action) => {
      const settings = {
        method: 'POST',
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        url: `${Config.API_BASE}/v2/support`,
        body: action.payload,
      }

      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.REQUEST_ACCESS_FULFILLED,
            payload: payload.response,
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.REQUEST_ACCESS_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
  )
}

// AJAX call to sign in
export const signIn = (action$) => {
  return action$.pipe(
    filter((action) => action.type === actions.SIGN_IN),
    mergeMap((action) => {
      const params = {
        fields,
      }

      const queryParams = queryString.stringify(params, {
        arrayFormat: 'bracket',
        encode: true,
      })

      const settings = {
        method: 'POST',
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        url: `${Config.API_BASE}/auth/sign_in.json?${queryParams}`,
        body: action.payload,
      }

      return ajax(settings).pipe(
        map((payload) => {
          const headers = getAuthHeaders(payload.xhr)
          return {
            type: actions.SIGN_IN_FULFILLED,
            payload: {
              user: payload.response.user,
              headers,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.SIGN_IN_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
  )
}
